import { fuego } from '@store/firebase';
import { Ihashtag, IupdateHashtag } from '@typings/common/hashtag.interface';

export async function increaseHashtagCount({
  hashtagId,
  collectionPath,
}: IupdateHashtag) {
  const hashtagPath = `${collectionPath}Hashtag`;
  const hashtagRef = fuego.db.collection(hashtagPath);
  const hashData = await hashtagRef
    .doc(hashtagId)
    .get()
    .then((res) => res.data());

  if (hashData)
    return hashtagRef
      .doc(hashtagId)
      .set({ count: hashData.count + 1 }, { merge: true });
}

export async function addHashDocIdList({ hashtagId, collectionPath, docId }) {
  const hashtagPath = `${collectionPath}Hashtag`;
  const hashtagRef = fuego.db.collection(hashtagPath);
  const hashData = await hashtagRef
    .doc(hashtagId)
    .get()
    .then((res) => res.data());

  if (hashData) {
    const prevData = hashData.docIdList;
    // 기존 IDLIST에 중복 문서가 없을 경우에만 추가
    if (!prevData.includes(docId))
      return hashtagRef
        .doc(hashtagId)
        .set({ docIdList: [...hashData.docIdList, docId] }, { merge: true });
  }
}

function getHashtagLength(hashtagPath: string) {
  const hashtagRef = fuego.db.collection(hashtagPath);
  return hashtagRef.get().then((res) => {
    return res.docs.length;
  });
}

interface IaddHashtag {
  hashtagValue: string;
  collectionPath: string;
  index?: number;
}

export async function addHashtagAndGetId({
  hashtagValue,
  collectionPath,
  index,
}: IaddHashtag) {
  const hashtagRef = fuego.db.collection(`${collectionPath}Hashtag`);
  const order = await getHashtagLength(`${collectionPath}Hashtag`);
  const newData = {
    value: hashtagValue,
    order: !index ? order : order + index,
    count: 0,
    docIdList: [],
  };
  const newId = hashtagRef.add(newData).then((res) => res.id);
  return newId;
}

export async function addHashtagAndGetData({
  hashtagValue,
  collectionPath,
  index,
}: IaddHashtag): Promise<Ihashtag> {
  const hashtagRef = fuego.db.collection(`${collectionPath}Hashtag`);
  const newId = await addHashtagAndGetId({
    hashtagValue,
    collectionPath,
    index,
  });

  return hashtagRef
    .doc(newId)
    .get()
    .then((res: any) => {
      return { ...res.data(), id: newId };
    });
}
